import * as React from 'react'

import { Product } from 'even-ts-static'

import { CreditCardApplicationContainer } from '../../components/Credit/container'
import { Deposits } from '../../components/Deposits/container'
import { LifeInsuranceContainer as LifeInsurance } from '../../components/LifeInsurance/container'
import Loan from '../../components/Loan/container'
import Mortgage from '../../components/Mortgage/container'

interface Props {
  availableProducts: Product[]
  selectedProduct: Product
}

export const SelectedProductView: React.FC<Props> = ({ availableProducts, selectedProduct }) => {
  const productByName = {
    [Product.CreditCard]: <CreditCardApplicationContainer />,
    [Product.Loan]: <Loan />,
    [Product.Mortgage]: <Mortgage />,
    [Product.Deposits]: <Deposits />,
    [Product.LifeInsurance]: <LifeInsurance />,
  }

  switch (selectedProduct) {
    case Product.CreditCard:
    case Product.Loan:
    case Product.Mortgage:
    case Product.Deposits:
    case Product.LifeInsurance:
      return productByName[selectedProduct]
    default:
      return availableProducts.length > 0 ? productByName[availableProducts[0]] : <div>No product selected</div>
  }
}
